import { configureStore } from '@reduxjs/toolkit';
import appReducer from './reducers/graphqlReducers';

const store = configureStore({
    reducer: {
        graphql: appReducer
    }
});

export default store;